export default "__VITE_PUBLIC_ASSET__5746c548__"